// src/data/interviewCards.js
import nakataniImage from '../assets/images/nakatani.png';
import nakataniIconImage from '../assets/images/nakatani_icon.png';
import nagataImage from '../assets/images/nagata.png';
import nagataIconImage from '../assets/images/nagata_icon.png';
// 中谷（悠人＝はると）さんインタビューの記事冒頭・本文中写真
import haruto1 from '../assets/images/haruto1.jpg';
import haruto2_1 from '../assets/images/haruto2-1.jpg';
import haruto2_2 from '../assets/images/haruto2-2.jpg';
import haruto3 from '../assets/images/haruto3.jpg';
import haruto4 from '../assets/images/haruto4.jpg';
import haruto5 from '../assets/images/haruto5.jpg';
// 酒井さんインタビューの写真
import sakaiImage from '../assets/images/sakai1.jpg';
import sakaiIconImage from '../assets/images/sakai_icon.png';
import sakai2 from '../assets/images/sakai2.jpg';
import sakai3 from '../assets/images/sakai3.jpg';
import sakai4 from '../assets/images/sakai4.jpg';
import sakai5 from '../assets/images/sakai5.jpg';
// 大木さんインタビューの写真
import ookiImage from '../assets/images/ooki1.jpg';
import ookiIconImage from '../assets/images/icon_oki.png';
import ooki2 from '../assets/images/ooki2.jpg';
import ooki3 from '../assets/images/ooki3.jpg';
import ooki4 from '../assets/images/ooki4.jpg';

const interviewCards = [
  {
    id: 1,
    breadcrumbLabel: '個別インタビュー01',
    type: 'individual',
    title: "学校行事でのいじめがきっかけで不登校に。葛藤しつつも、第3の居場所と趣味が心の支えに",
    description: "中学1年生から不登校を経験し、一度全日制高校に進学するも再度不登校へ。そこから通信制高校への転校を決意した中谷悠人さんに、家族や友人との関わり、そして「自分の道」を見つけるまでの葛藤をお聞きしました。",
    authorName: "まりぽり",
    authorInitial: "R",
    date: "2025.07.01",
    image: nakataniImage,      // 一覧カードのサムネイル
    heroImage: haruto1,        // 記事冒頭の写真（サムネイルとは別）
    iconImage: nakataniIconImage,

    // ▼ 詳細ページ用 ▼
    fullName: "中谷 悠人",
    profile: "福井県在住、通信制高校3年生",
    interviewDate: "2025年7月",

    introduction: [
      "今回は、現在通信制高校3年生の中谷悠人さんにインタビューしました。悠人さんは、中学1年生から不登校を経験し、一度全日制高校に進学するも、再度不登校を経験。そこから学生生活の送り方や居場所のあり方を家族で見つめ直し、通信制高校への転校を決意しました。",
      "現在は通信制高校の授業と両立しながら、学校の垣根を越えた学生団体や演劇、音楽活動などに打ち込む悠人さん。アクティブに活躍している彼ですが、現在に至るまでの葛藤や選択、家族や先生・友人との関わりについてお話をお聞きしました。"
    ],

    // 各見出しに対応する短いラベル（配列の順序が sections と対応）
    tableOfContents: [
      "不登校のきっかけ",
      "進路選択と通信制への転校",
      "家族との関わり",
      "友人・先生との関わり",
      "同じ状況の方へのアドバイス"
    ],

    sections: [
      {
        heading: "学校行事でのいじめがきっかけで不登校に。葛藤しつつも、第3の居場所と趣味が心の支えに",
        qaList: [
          {
            question: "ー悠人さんが最初に学校に行きづらくなったのは中学生の時とお聞きしました。何かきっかけはありましたか？",
            answer: "悠人さん：中学1年生の秋に、軽いいじめに遭ったことです。体育祭のダンスに真面目に取り組まないクラスメイトからいじられて、気持ちがすごく落ち込んで…そこから学校に行けなくなりました。\n\n全日制の高校に進学してからは、しばらく頑張っていたのですが、頑張りすぎてしまって、不登校になりました。"
          },
          {
            question: "ー悠人さんが最初に学校に行きづらくなったのは中学生の時とお聞きしました。何かきっかけはありましたか？",
            answer: "悠人さん：中学1年生の秋に、軽いいじめに遭ったことです。体育祭のダンスに真面目に取り組まないクラスメイトからいじられて、気持ちがすごく落ち込んで…そこから学校に行けなくなりました。\n\n全日制の高校に進学してからは、しばらく頑張っていたのですが、頑張りすぎてしまって、不登校になりました。"
          },
          {
            question: "ー自分の興味のあることで、気分転換をしていたんですね。他に、何か気分転換ができることはありましたか？",
            answer: "悠人さん：母が、家と学校以外の第3の居場所をいくつか提案してくれました。不登校になって半年ほど経ったときに、母から勧めてもらった場所の1つの『NPO法人 もりのほうかごがっこう』という、小学生の子どもたちを対象とした「森の中で自由に遊ぶ」というイベントがとても楽しかったんです。同世代だけでなく、年下の子たちを交えた会話が楽しくて。\n\nそれを母に話したら、次のイベントからは「ジュニアスタッフ」として参加することになり、3年ほど行き続けていました。『もりのほうかごがっこう』の代表の方が不登校に理解がある方で、優しく接してくれましたし、異年齢の人と話すことも刺激があって、とても楽しかったです。\n\nあとは、オタ活ですね！ 福井県出身の作家さんが書いたライトノベル『千歳くんはラムネ瓶のなか』を読み始めて、そこからライトノベルにドハマりしました。200～300冊は読んだと思います。小さい頃から読書が好きで、物語を想像することも好きだったので、実際に演劇用の短編台本を書くことにも繋がりました。"
          },
          {
            question: "ー居場所を提案してもらえたり、好きなことがたくさんあったことが大きかったのですね。不登校の時の話に戻りますが、気分転換をしつつ学校から離れた生活を送っていたとき、どんな気持ちでしたか？",
            answer: "悠人さん：何かに打ち込んでいるときはそれに熱中できるのですが、一旦自分のしていることを横に置いたときに「学校に行けてない」「自分は普通じゃない」など、ネガティブな気持ちが出てきたり、母や祖父母に「迷惑をかけているな」と申し訳なくなったり、だけど「学校に行きたいのに行けないんだよな」と思う気持ちがループしていました。"
          },
          { type: 'image', src: haruto2_1 },
          { type: 'image', src: haruto2_2 }
        ]
      },
      {
        heading: "全日制高校進学後、二度目の不登校を経験。通信制高校への転校を機に視野が広がる",
        qaList: [
          {
            question: "ー不登校がきっかけで、自分の進路選択に影響はありましたか？",
            answer: "悠人さん：普通に中学校に行けていたら、もう少し成績も良かったのかなと思っていました。高校受験は自分の出来る範囲で頑張って、全日制の県立高校に進学しました。「高校では頑張ってみよう」と思っていて、機械関係の実習もあって楽しかったのですが、張り切りすぎてしまったのか、途中でダウンしてしまって。そこから再度不登校になりました。\n\n出席日数が足りなくなってしまい、「留年して今の高校に居続けるか」「転校して新しい環境でやり直すか」を考えたとき、別の環境の方が新しい経験もできるということで転校を決意しました。そこで全日制か通信制かでも迷ったのですが、「通信制の方が合っているかもしれない」と思い、通信制高校に転校しました。"
          },
          {
            question: "ー今は通信制高校もたくさんあり、選択肢も多いですよね。今在籍している学校を選んだ決め手などはありますか？",
            answer: "悠人さん：一番の決め手は、学校でVRゴーグルが支給されることですね。VRゴーグルを使った授業があって、バーチャル空間上で理科の実験ができたり、歴史の授業で有名なお城を近くで見ることができたり、近未来的な授業が面白そうだと思いました。他にも、インターネット関係で活躍している技術者の方から、プログラミングやイラストなどの授業を受けられたりもするんですよ。通信制なので、授業と自分の活動との両立も出来ますし、選択肢や視野が広がって、今の自分には合っているなと思っています。"
          },
          {
            question: "ー自分に合った学校選択が出来てよかったですね！ 今の悠人さんは、学校の垣根を越えた学生団体の活動をしたり、演劇をしたりなど、とても生き生きとしているように感じています。辛い時期もあったと思いますが、少しずつ心が元気になっていったきっかけなどはありますか？",
            answer: "悠人さん：そうだなあ…いつの間にか、でした。\n\n要因を挙げるとすると、『もりのほうかごがっこう』でジュニアスタッフとして活動していたことと、中学3年生の時に劇団に入ったことですかね。『もりのほうかごがっこう』では、異年齢の人たちと一緒に活動できて、今までになかった新しい刺激をもらえて、コミュニケーションもどんどん好きになっていきました。昼夜逆転の生活を送っていた時期ではあったのですが、活動がある日は生活リズムを直すことが出来ました。\n\n演劇だと、同年代の仲間達と1つのものを作り上げることがすごく楽しくて、学校ではできなかった経験ができていることが良かったなと思います。\n\n高校の時は、親友の存在がターニングポイントでした。同じ高校にいた友人なのですが、転校してから学生イベントで再会したんです。そこから同じ学校だったときよりも仲良くなって、今では毎週会うほどです。その時期に彼から誘われて、学生団体を設立したことも自分の中で大きかったです。"
          },
          { type: 'image', src: haruto3 }
        ]
      },
      {
        heading: "行けなかった時期、母が前向きに寄り添ってくれたことで救われた",
        qaList: [
          {
            question: "ー不登校になったときに「学校に行けない」ということを、家族に話せましたか？",
            answer: "悠人さん：母・祖父母は私が学校に行けないことに対して理解はしてくれていたのですが、他人も含めて話すことはできなかったですね。学校を休み始めて、しばらくは話せなかったです。元々受け身の性格なのもあって、母が歩み寄ってくれて、居場所を見つけたり、外に出たりできるようになりました。"
          },
          {
            question: "ー不登校の時期、家族との関係性はどうでしたか？ 「学校に行きなさい」と言われたりなどはありましたか？",
            answer: "悠人さん：最初の1ヶ月ほどは母と祖母から「学校に行きなさい」と言われていました。祖父はあまり干渉しないタイプだったのですが、時折話しかけてくれていました。学校に行けなくなって半年ほど経って、『もりのほうかごがっこう』など居場所ができたときくらいから、母からは「学校に行きなさい」とは言われなくなりました。"
          },
          {
            question: "ー家族から言われて傷ついたこと、やってほしくなかったこと・言ってほしくなかったことはありますか？",
            answer: "悠人さん：何を言われても、自分が悪いと思って受け入れていましたが、「学校に行かないと将来がなくなるよ」と言われたときは辛かったです。「自分の人生は終わってしまうのか…」と思ったり…"
          },
          {
            question: "ー家族から言われて救われたことはありますか？",
            answer: "悠人さん：母が「不登校でもいいよね」と考えてくれて、寄り添ってくれたことです。ずっと母は寄り添ってくれていたんですが、「いいよね」という前向きなスタンスで居てくれたときは嬉しかったなと思います。"
          },
          { type: 'image', src: haruto4 }
        ]
      },
      {
        heading: "一人の人間として接してくれた友人と、選択肢を与えてくれた恩師への感謝",
        qaList: [
          {
            question: "ー友達や先生から言われて傷ついたこと、やってほしくなかったことはありますか？",
            answer: "悠人さん：いじめの原因（学校行事でのクラスメイトからのいじり）さえなければ、と思います。先生は親身になってくれました。"
          },
          {
            question: "ー友達や先生に言われて救われたことはありますか？",
            answer: "悠人さん：高校受験の時期だけ学校に戻れていたのですが、面接練習のときに同じ部活の子が「久しぶり！」と声をかけてくれたことです。不登校関係なく「久しぶりに会った友達」として接してくれたのが嬉しくて。不登校ということを気にせずに、一人の人間として自分を見てくれている人がいるということに救われました。\n\nまた、高校を辞めるかどうかで迷っていたときに、先生が「辞めてもいい」と言ってくれたことも救われたことのひとつです。先生自身は「クラスの生徒全員を卒業まで見たい」と思ってくれていたようですが…それでも、選択肢を与えてくれたことは嬉しかったな。"
          },
          {
            question: "ー自分を一人の人間として見てくれていることや、悠人さんの人生にとってベストな選択肢を探してくれたことは大きいですね。不登校の経験や、不登校がきっかけで学校を変えたことなどを、誰かに話すことはできましたか？",
            answer: "悠人さん：相手から聞かれない限りは話さないかな。自分から話すようなことでも無いと思いますし。関係性を作る上で話さなきゃいけないときは、話しています。"
          },
          { type: 'image', src: haruto5 }
        ]
      },
      {
        heading: "「あとは、なるようになる！」不登校の経験から得られた人生の糧",
        qaList: [
          {
            question: "ー悠人さんが、不登校の経験から得たものはありますか？",
            answer: "悠人さん：学校から外れたことで、学校に行っているだけではできない体験・経験ができたことが大きいです。課外活動や趣味、オタ活など…自分の好きなものにたくさん触れることができました。\n\nまた、年上の人や年下の子など、自分とは違う世界の人たちと接することができて、普通に学校に行っているだけではできない経験をさせてもらえたなと思います。"
          },
          {
            question: "ー学校から離れたことを通して、悠人さんに合っていた世界に導かれたように感じられますね。学生の段階で異年齢の人とのコミュニケーションを大切にできていることはとても大切なように思えます。最後に、読んでいる方に伝えたいことありますか？",
            answer: "悠人さん：自分がここまで自由にできたのは、周りの大人や友達がたくさん引っ張ってきてくれたから。自分の力で解決しようと思ったこともあったけど「そんなことないよ」って。誰かに頼ることも重要なことであって、自分ひとりだけでは一方的な面しか見られないけれど、誰かを介すことで、いろんな角度からいろんな視点を入れて、時には問題を解決することができるときもありますし、問題が増えることもありますが…誰かに話してみることも一つの選択肢としていいのかなと。あとは、なるようになります！"
          },
          {
            question: "ー「あとは、なるようになる」大切な考えですね！ 貴重なお話を聞かせていただき、ありがとうございました！"
          }
        ]
      }
    ],

    writer: {
      name: "えみか",
      description: "30代、2児の母。高校生の時に不登校経験あり。教員免許所持。現在は育児をしながらライター活動を行う。"
    }
  },
  {
    id: 2,
    breadcrumbLabel: '支援者からのメッセージ１',
    type: 'supporter',
    title: "支援者のみなさんからの\nメッセージ",
    description: "こどもがこどもでいられる時間はあっちゅう間",
    authorName: "まりぽり",
    authorInitial: "R",
    date: "2025.08.01",
    image: nagataImage,
    iconImage: nagataIconImage,

    // ▼ 詳細ページ用 ▼
    fullName: "永田 弘幸",
    profile: "特定非営利活動法人 BRICOLAB代表理事",
    interviewDate: "2025年8月",

    introduction: [
      "こどもがこどもでいられる時間はあっちゅう間。罪悪感を持ってこどもでいられるわずかな時間を過ごさせるのは勿体無い。",
      "\u201c今は学校にいかないと決めた子\u201dもあっという間に大人になる。大人になった時に思い出すのは、一緒に笑ってくれていた大人たちのことかも。",
      "私たち大人ができることは、私たち自身が、朝が待ち遠しいぐらいの日々を過ごして、顔を上げて生きている姿を見せてあげること。あとはいろんな選択肢を用意して、子どもが自分自身を教育するのを眺めてあげること。「学校しかない」と思っていた子たちに、耳元でコソッと「学校もあるよ」と呟いてあげる。"
    ],

    // tableOfContents を省略 → 目次は非表示

    sections: [],

    // writer を省略 → ライター紹介は非表示
  },
  {
    id: 3,
    breadcrumbLabel: '個別インタビュー02',
    type: 'individual',
    title: "もともと学校生活に違和感。起立性調節障害で突然体が動かなくなり、不登校に",
    description: "小学生のころから学校への違和感を持ち、中学1年生で起立性調節障害に。中学校を卒業するまで不登校を経験し、現在は児童福祉の団体職員として子どもたちに寄り添う酒井優起さんに、当時の葛藤と今につながる支えについてお聞きしました。",
    authorName: "まりぽり",
    authorInitial: "R",
    date: "2025.08.01",
    image: sakaiImage,
    iconImage: sakaiIconImage,

    // ▼ 詳細ページ用 ▼
    fullName: "酒井 優起",
    profile: "福井県在住、団体職員",
    interviewDate: "2025年8月",

    introduction: [
      "今回は、福井県で児童福祉に関する団体職員として働く、酒井優起さんにインタビューを行いました。酒井さんは、小学生のころから学校への違和感を持ち、中学1年生の時に起立性調節障害になったことをきっかけに、中学校を卒業するまで不登校を経験しました。",
      "現在は児童福祉関連の団体職員として、悩みや困りごとを持つ子どもたちに寄り添う仕事をしている酒井さん。今では多くの子どもたちから信頼され頼られる存在ですが、ここに至るまでには深い悩みや葛藤がありました。自責・家族との関係・進路…そんな中で環境の変化や周囲の支えによって少しずつ変わっていった経験についてお話をお聞きしました。"
    ],

    // 各見出しに対応する短いラベル（配列の順序が sections と対応）
    tableOfContents: [
      "不登校のきっかけ",
      "高校進学と再スタート",
      "家族との関わり",
      "友人・先生との関わり",
      "同じ状況の方へのアドバイス"
    ],

    sections: [
      {
        heading: "もともと学校生活に違和感。起立性調節障害で突然体が動かなくなり、不登校に",
        qaList: [
          {
            question: "ー酒井さんが最初に学校に行きづらくなったきっかけはありましたか？",
            answer: "酒井さん：中学1年生の冬に、起立性調節障害になったことです。朝に体調が悪く、夕方に戻るという感じでした。\nもともと小学3年生の時に引っ越しをして、転校先の学校が合わず、学校に行くモチベーションも低かったこともありました。\n\n高校は市外の私立高校に進学し、環境が変わったことで、体調に合わせながら通学することができました。"
          },
          {
            question: "ー自分の興味のあることで、気分転換をしていたんですね。他に、何か気分転換ができることはありましたか？",
            answer: "酒井さん：最初はほとんど動けなかったです。起立性調節障害の影響で体が動かず…横になってゲームをしたり、漫画を読んだり。半年ほど経った頃に、父に「海、行くか！」と誘われたことをきっかけに、少しずつ外出できるようになりました。そこからは両親の助けもあり、昼夜逆転気味でしたが適応指導教室にもきちんと行けるようになりました。"
          },
          {
            question: "ーお父さんの言葉、とても有難かったですね！　なかなか、そういった言葉掛けと寄り添い方をしたくてもできないこともあると思います。",
            answer: "酒井さん：本当にそう思います。父が交代制の仕事で、昼に家にいることも大きかったです。海に行くだけでなく、加賀の公園まで散歩に行ったりも大きな気分転換になりました。\n\nあとは、ゲームやテレビ、漫画などにも助けられました。特にオンラインゲームは、当時の自分にとっては第三の居場所になっていたと思います。"
          },
          {
            question: "ー家でも学校でもない居場所やコミュニティは大切ですよね。ですが、学校に行けていないということも、気になっていたのかなと思います。当時はどんな気持ちでしたか？",
            answer: "酒井さん：とにかく、いろんなことを考えていました。「行かなきゃ」「このままじゃダメだ」と。しんどかったです。学校のことを考えない日は一度もなかった。中学3年生で相談室まで行けるようになったのですが、同い年の子たちに何か言われるのが怖くて、ハードルが高かったです。"
          },
          { type: 'image', src: sakai2 }
        ]
      },
      {
        heading: "部活の友人の影響で、高校進学へ前向きな気持ちに。「そこで頑張ろう」と再スタートを切れた高校時代",
        qaList: [
          {
            question: "ー不登校がきっかけで、高校受験など自分の進路選択に影響はありましたか？",
            answer: "酒井さん：そこまで進路選択が変わった意識はなかったです。高校に行きたい気持ちはありました。部活の友人が家によく遊びに来てくれていたので。「もっと学校に行けていたら…」と思うことはありましたが、三者面談で市外の私立高校を勧められ、「そこで頑張ろう」と思いました。"
          },
          {
            question: "ー高校での再スタートを決意されたんですね。",
            answer: "酒井さん：そうですね。経済・経営の授業もあったので、ここならいいかもと思いました。"
          },
          {
            question: "ー特色があって楽しそうな学校ですね！高校では楽しく過ごすことができましたか？",
            answer: "酒井さん：大きな環境変化があり、体調と相談しながらではありますが、学業、加えてアルバイトも続けることができました。高校では新しい出会いもあり、ゲームや音楽など好きなことも増え、バンドを組むなど社会との繋がりも増えました。"
          },
          { type: 'image', src: sakai3 }
        ]
      },
      {
        heading: "心配しつつも「待ち」の姿勢でいてくれたことに感謝",
        qaList: [
          {
            question: "ー不登校になったときに「学校に行けない」ということを、家族に話せましたか？",
            answer: "酒井さん：はい。起立性調節障害になったときに「行きたくてもいけない」と伝えました。"
          },
          {
            question: "ーご両親の反応などはありましたか？　「学校に行きなさい」と言われたりなどはありましたか？",
            answer: "酒井さん：最初は「行けよ」「何で行けんのや」「これからどうするんや」と親としての不安を一通りぶつけられていたと思いますが、最終的には気持ちを尊重してくれました。親も不安だったでしょうけど、関係性はよかったと思います。"
          },
          {
            question: "ー家族からの働きかけや言われたことで救われたことはありますか？",
            answer: "酒井さん：親からスクールカウンセラーに相談してくれたり、待ちの姿勢でいてくれたことです。また、海に行ったりバンドに挑戦したりなど、学校以外の社会参加も親に促してもらって、協力してもらってのことでした。"
          },
          { type: 'image', src: sakai4 }
        ]
      },
      {
        heading: "「不登校だから」というフィルタを外して見てくれた、友人と恩師への感謝",
        qaList: [
          {
            question: "ー友達や先生から言われて傷ついたこと、やってほしくなかったことはありますか？",
            answer: "酒井さん：友人から「学校来ないのに、部活とか修学旅行は来るんや」と言われたときは傷つきました。中学校の先生は優しかったのですが、小学校の時、行き渋りがあった時期に「37.1℃で来ないとアカンわ」と言われ、寄り添ってくれないことが嫌だったです。"
          },
          {
            question: "ー友達や先生に言われて救われたことはありますか？",
            answer: "酒井さん：友人が毎日遊びに来てくれたことは大きいです。不登校関係なく、土日に集まって遊んだりして。さっきも言ったように、中学校の先生にはとても救われました。待ちの姿勢でいてくれて、「1人の生徒として」話を聞いてくれました。"
          },
          {
            question: "ーご友人も、先生も、酒井さんが「不登校だから」というスタンスではなく、1人の友人・生徒として見てくれていることが本当によかったように思えます。不登校の経験や、そのとき感じていたことなどを、誰かに話すことはできましたか？",
            answer: "酒井さん：今は話せます。年齢が上がることによって、どんどん冷静に話せるようになりました。大学時代は信頼できる友人にのみ話すといった感じでした。"
          },
          { type: 'image', src: sakai5 }
        ]
      },
      {
        heading: "「1回の失敗が全てではない」しんどかったからこそ、今、子どもたちと接することに活きている",
        qaList: [
          {
            question: "ー酒井さんが、不登校の経験から得たものはありますか？",
            answer: "酒井さん：今、私は児童福祉の道に進んでいます。不登校の経験をして、「支援者に回りたい」という気持ちが生まれ、今の仕事に就いています。当時、しんどかったからこそ、今困りごとや悩みごとを抱えている子供たちに声掛けができるのかなと思います。子どもたちとは「縦」でも「横」でもなく、「斜め上」の存在。これからも子どもたちとは「話しやすいお兄ちゃん」のような存在でいられたらいいですね。\n\nまた、不登校の経験があったから、人に優しくできたり、気配りができるようになったのかなと思っています。"
          },
          {
            question: "ーご自身の経験が、今子どもたちと接する上で大きな糧となっているのですね。最後に、読んでいる方に伝えたいことありますか？",
            answer: "酒井さん：不登校になって「人生挫折した」と思ったけど、死ぬわけじゃない。今はやりたかったことができています。1回の失敗が全てではないことを伝えたいです。"
          },
          {
            question: "ー「1回の失敗が全てではない」本当にそうですね。きっと関わっている子どもたちにも伝わっていると思います。貴重なお話を聞かせていただき、ありがとうございました！"
          }
        ]
      }
    ],

    writer: {
      name: "えみか",
      description: "30代、2児の母。高校生の時に不登校経験あり。教員免許所持。現在は育児をしながらライター活動を行う。"
    }
  },
  {
    id: 4,
    breadcrumbLabel: '個別インタビュー03',
    type: 'individual',
    title: "もともと学校への違和感があった小学生時代。起立性調節障害をきっかけに翌日から学校を休むように",
    description: "小学生の時から校風への違和感やいじめで学校への行きづらさを感じ、中学2年生で起立性調節障害をきっかけに不登校に。現在は地域活性化の仕事に打ち込む大木百香さん（仮名）に、当時の葛藤と進路選択についてお聞きしました。",
    authorName: "まりぽり",
    authorInitial: "R",
    date: "2025.08.01",
    image: ookiImage,
    iconImage: ookiIconImage,

    // ▼ 詳細ページ用 ▼
    fullName: "大木 百香",
    profile: "仮名、福井県在住・会社員",
    interviewDate: "2025年8月",

    introduction: [
      "今回は、福井県で地域活性化に関する仕事をしている大木さんにインタビューしました。大木さんは、小学生の時から校風への違和感やいじめによって学校への行きづらさを感じ、中学2年生の時に起立性調節障害をきっかけに不登校を経験しました。",
      "現在は地域活性の若きリーダーとして、生き生きと仕事にまい進する大木さん。趣味のダンスや地域活動も充実し、とても活動的な大木さんですが、学生時代は学校に行けなかったことも含め、多くの葛藤や悩みがあったとのことでした。"
    ],

    // 各見出しに対応する短いラベル（配列の順序が sections と対応）
    tableOfContents: [
      "不登校のきっかけ",
      "通信制高校への進学",
      "家族・先生との関わり",
      "同じ状況の方へのアドバイス"
    ],

    sections: [
      {
        heading: "もともと学校への違和感があった小学生時代。起立性調節障害をきっかけに翌日から学校を休むように",
        qaList: [
          {
            question: "ー大木さんが最初に学校に行きづらくなったきっかけはありましたか？",
            answer: "大木さん：もともと学校はあまり好きではありませんでした。小学校中学年からいじめに遭い、学校の校風にも違和感があり…友人を信用できなかったり、部活の先生がパワハラ気質だったり、倒れる前から体調不良はありました。\n\n中学生の時、成長期で急に身長が伸びたことで起立性調節障害になり、急にお風呂で倒れてしまって。病院で診断をされた翌日から学校に行けなくなりました。「行かなきゃ」とは思っていたのですが、学校が楽しいと思えなかったこともあり、そこから不登校になりました。"
          },
          {
            question: "ー学校に行けていない時間は、どのように過ごしていましたか？",
            answer: "大木さん：まずは起立性調節障害の症状で全く動けませんでした。トイレに行くのがやっとで、そんな自分が悔しくて泣いていた記憶があります。\n\nまずは何もしない時間を作って、とことん休みました。そこから、少しずつ動画投稿サイトにハマったり、ミュージカル映画を観賞したりしていました。"
          },
          {
            question: "ー体が動かなくなってしまったのはとてもしんどかったと思います…。ですが、少しずつ趣味ができたことは大きいですね。他に、何か気分転換ができることはありましたか？",
            answer: "大木さん：ニコニコ動画をよく見ていました。そこからボーカロイドや歌い手さん、アニメなどが好きになったり、音楽鑑賞をしたり。あとはペットの猫に癒されていました。家族が音楽好きで、その影響もあり、音楽にはたくさん救われたと思います。音楽がテーマの学園アニメを見て励まされたりもしていました。"
          },
          {
            question: "ー音楽の力は大きいですね。不登校のときの話に戻りますが、学校に行けなくなったときはどんな気持ちでしたか？",
            answer: "大木さん：最初はとにかく自分を責めていました。「行かなきゃ」「なんで自分が？」「できない子だ」「怠けているって言われるかも」など…"
          },
          {
            question: "ーしんどかったですね。",
            answer: "大木さん：しんどかったです。起立性調節障害の症状が落ち着いてきたころには「行かなくても大丈夫かも」と思うようになりました。"
          },
          { type: 'image', src: ooki2 }
        ]
      },
      {
        heading: "カウンセラーさんに勧められ、通信制の高校へ。目的や目標のために体調を整えられるように",
        qaList: [
          {
            question: "ー不登校がきっかけで、自分の進路選択に影響はありましたか？",
            answer: "大木さん：本当は行きたい高校がありました。ずっと習っていたダンスに特化した部活がある高校で、そのために勉強もしていたのですが、体調不良でオープンキャンパスにも行けず…そこで、カウンセラーの先生に勧められて、全国に拠点のある通信制高校への進学を考え始めました。"
          },
          {
            question: "ー進学した学校を選んだ決め手などはありますか？",
            answer: "大木さん：オープンキャンパスがとても楽しかったんです。そこで友達もできたくらい。勉強もパソコンや音楽、料理、あとは大学進学クラスなど、自分の目標や興味に合わせた授業を受けることができるんです。\nもともと栄養学に興味があり「勉強しなきゃ」と思い、心が固まりました。\n\n通信制高校への進学を決めたあたりから、別室登校ができるようになりました。そこで先生と進路の話をする中で、受験を後押ししてもらえました。"
          },
          {
            question: "ー目的ができたことで、学校にも少しずつ戻れるようになったんですね！",
            answer: "大木さん：そうですね。中学3年生くらいから、午後から学校に行けるようになりました。志望校が決まったことが大きいですね。別室登校ができるようになり、受験のための小論文や面接の練習もできるようになりました。目的ができたことで、少しずつ元気になっていったのかなと思います。"
          },
          {
            question: "ー高校からは元気に学校生活を送れたのでしょうか？",
            answer: "大木さん：実は、高校1年生のときはまだ体調が戻り切っていませんでした。授業のために体調を整えていました。高校1年生の後半になって、やっと体調が治り、そこから授業もきちんと行けるようになりました。"
          },
          { type: 'image', src: ooki3 }
        ]
      },
      {
        heading: "「好きなようにやればいい」と理解を示してくれた両親と「よく来たね」と認めてくれる恩師に救われた",
        qaList: [
          {
            question: "ー不登校になったときに「学校に行けない」ということを、家族に話せましたか？",
            answer: "大木さん：自宅で倒れたことが不登校のきっかけだったので、家族も「これは学校に行けないな…」と思っていたようです。ですが、全て家族に話せるわけではなく、小学校の時にいじめられていたことは話せませんでした。"
          },
          {
            question: "ー不登校の時期、「学校に行きなさい」と言われたりなどはありましたか？",
            answer: "大木さん：「そろそろ行ったら？」という態度には出ていたと思います。母はルールやマナーに厳しい部分もありましたが、いじめなどに対する理解があったので「無理しないで」と言ってくれました。父からは「どうして行けないの？」とは言われましたが「でも、好きなようにしなさい」と言ってくれました。"
          },
          {
            question: "ー家族から言われて救われたことはありますか？",
            answer: "大木さん：学校と掛け合ってくれたことは大きかったです。別の中学校に行く選択肢も与えてくれました。「百香が好きなようにやればいい」と、習い事にも行かせてくれたり、高校卒業後の進路選択も支えてくれたことには感謝しています。"
          },
          {
            question: "ーまた、先生に言われて救われたことはありますか？",
            answer: "大木さん：中学校のときの担任の先生には救われました。話を聞いてくれたり、心配してくれたり…中学3年生のときの先生は「来れなくても大丈夫」といったスタンスでいてくれて、学校に行けたときに「よく来たね」と褒めてくれて。本当に有難かったです。"
          },
          { type: 'image', src: ooki4 }
        ]
      },
      {
        heading: "学校から離れた時間で、得られたものはある。全てがおじゃんになるわけではない",
        qaList: [
          {
            question: "ー不登校の経験を誰かに話すことはできましたか？",
            answer: "大木さん：高校の友人には話せました。通信制高校ということもあり、似た境遇の友人も多かったので。短大や社会人になってからは、しばらく伏せていました。通信制高校へ通っていたことは「病気で…」と濁していましたが、県の講座でモチベーショングラフ（※）を作ったときに、「言っても大丈夫」「言わないと、次のステージに上がれないかも」と吹っ切れて、言えるようになりました。\n\n※モチベーショングラフ：自身の人生を振り返り、過去の出来事とモチベーションの高低を時系列で折れ線グラフに表した、自己分析ツールのこと"
          },
          {
            question: "ー大木さんが、不登校の経験から得たものはありますか？",
            answer: "大木さん：まずは、音楽が好きになりました。不登校の時も、今も、音楽の力に助けられることが多々あります。あとは、言葉を大切に使うこと、人を傷つけないようにすることも、悩んでいた時期から得られた大きな事だと思います。\n\n通信制高校という進路選択ができたことで、アルバイトを通して社会経験を積むことができ、早い段階で大人になれたことも大きかったです。特にパン屋さんでのアルバイトは、朝起きられるきっかけにもなりました。"
          },
          {
            question: "ー最後に、読んでいる方に伝えたいことありますか？",
            answer: "大木さん：まず「不登校になっても大丈夫だよ」と伝えたいです。不登校になったからといって、全ての人生がおじゃんになるわけではないです。当時は不安だったし、周りに心配もかけたけど、今は社会人として働けていますし、長い目で見たらなんとかなった。学校から離れることで視野が広がるきっかけにもなるかもしれないし、何かができる時間にもなるかもしれないですしね。自分が好きなことが1つでもあれば、それで良いと思います。"
          },
          {
            question: "ー貴重なお話を聞かせていただき、ありがとうございました！"
          }
        ]
      }
    ],

    writer: {
      name: "えみか",
      description: "30代、2児の母。高校生の時に不登校経験あり。教員免許所持。現在は育児をしながらライター活動を行う。"
    }
  }
];

export default interviewCards;